import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import BrowseApp from 'bundles/browse/components/BrowseApp';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';

const DomainPage = loadOnRoute(() => import('bundles/browse/components/Domain/DomainPage'));
const AllDomainV2Page = loadOnRoute(() => import('bundles/browse/v2/pages/AllDomainV2Page'));
const DomainV2Page = loadOnRoute(() => import('bundles/browse/v2/pages/DomainV2Page'));

const BrowseAppWithUserExperienceHandler = (props: React.ComponentProps<typeof BrowseApp>) => (
  <UnifiedUserExperienceHandler>
    <BrowseApp {...props} />
  </UnifiedUserExperienceHandler>
);

/* eslint-disable new-cap */
/* eslint-disable @babel/new-cap */

export default (
  <CourseraRoute
    path="/"
    component={BrowseAppWithUserExperienceHandler}
    handle={{
      tracking: {
        data: () => {
          return {
            page: {
              segment: 'consumer',
              type: 'browse',
            },
          };
        },
      },
    }}
  >
    <Route path="browse" getComponent={AllDomainV2Page} />

    <Route path="browse/:domainSlug" getComponent={DomainV2Page} />
    <Route path="browse/:domainSlug/:subdomainSlug" getComponent={DomainPage} />
    <Route path="/*" component={NotFound} />
  </CourseraRoute>
);
